import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { TextField } from '@mui/material';
import { isDate } from 'lodash';
import React from 'react';
import { DatePickerProps } from './types';

const DatePickerInput: React.FC<DatePickerProps> = (props) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={props.label}
                value={props.value}
                minDate={props.minDate}
                allowSameDateSelection={true}
                onChange={(dateTime) => {
                    if (!dateTime) return;
                    const date = new Date(dateTime);
                    if (!props.item || isDate(props.item)) props.setItem(date);
                    else
                        props.setItem({
                            ...props.item,
                            [props.name]: date,
                        });
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
            />
        </LocalizationProvider>
    );
};

export default DatePickerInput;
